<template>



  <div>



  <div ref="thecartcart" >
       <h3>My Cart Items</h3>
       </div>
        <b-table
             detailed
             detail-key="naics"
             @details-open="(row, index) => $buefy.toast.open(`Expanded ${row.user.first_name}`)"
              :show-detail-icon="showDetailIcon"
              :opened-detailed="defaultOpenedDetails"
        :data="myCart" >
        <template scope="props">
              <b-table-column field="naics" label="NAICS">{{props.row.cartProduct.naics}}</b-table-column>
              <b-table-column field="description" label="Description">{{props.row.cartProduct.description}}</b-table-column>
              <b-table-column field="region" label="Region">National</b-table-column>

              <b-table-column field="delete" label="Sales Size">

              <b-field label=""  :type="props.row.render.type" :message="props.row.render.message" >
              <p class="control">
      <b-select placeholder="Choose Sales Size" v-model="selected_id[props.row.index]" @input="doCustomSales(props.row.cartProduct.naics)" required>
      <<option value="Input">Exact Sales</option>
      <<option value="Range-03-Less than $250K">Less than $250K</option>
      <<option value="Range-04->$250-$500K">$250-$500K</option>
      <<option value="Range-05-$500K-$1M">$500K-$1M</option>
      <<option value="Range-06-$1M-$2.5M">$1M-$2.5M</option>
      <<option value="Range-07-$2.5M-$5M">$2.5M-$5M</option>
      <<option value="Range-08-$5M-10M">$5M-10M</option>
      <<option value="Range-09-$10M-25M">$10M-25M</option>
      <<option value="Range-10-$25M-50M">$25M-50M</option>
      <<option value="Range-11-$50M-100M">$50M-100M</option>
      <<option value="Range-12-$100M-250M">$100M-250M</option>
      <<option value="Range-13-$250M-500M">$250M-500M</option>
      <<option value="Range-14-$500M+">$500M plus</option>


      </b-select>

      <b-input v-bind:style="{ visibility: selected_id[props.row.index] == 'Input' ? 'visible' : 'hidden' }"  v-model="input_id[props.row.index]"  placeholder="Enter Your Sales"></b-input>

      </p>
  </b-field>

  </b-table-column>

  <b-table-column field="price" label="Price">{{props.row.price}}</b-table-column>

  <b-table-column field="delete" label="">
  <b-button @click="deleteItem(props.row.index)">Delete</b-button>
  </b-table-column>

            </template>

        </b-table>
        <div class="buttons">
       <b-button type="is-primary"  @click="checkoutNow" expanded>Checkout</b-button>
      </div>
        </div>




</template>

<script>
import axios from 'axios'
import { mapState , mapGetters} from "vuex";
import { CART_UPDATE,CART_RENDER, CART_VALIDATE,CART_DELETE , CART_RESTAPI } from "../store/actions/cart";

export default {
  name: 'CartViewer',
  components: {  },
  data () {
    return {
    checkboxGroup: [],
    radioButton: [],
    checkRange: true,
    checkExact: false,
    showDetailIcon: false ,
    radio: [],
    dropdown_id: [],
    defaultOpenedDetails: [],
      data: [],
      thetotal: "10",
      selected_id: [],
      input_id: [],
      input_id2: [],
      myItems: [],
      selected: null,
      isFetching: false,
      rerender: [],
      thetype: [],
      themessage: []
    }
  },
  computed: {
  ...mapState({
  myCart: state => state.cart.products,
  status: state => state.cart.status,
  }),
    doRerender () {
      return this.rerender
    }
  },
  watch: {

},
  mounted () {
    this.$store.commit(CART_RESTAPI, this.$api.REST_API)

  console.log("CartViewer - mounted():")

  var axiosData = this.mapaxiosData

  console.log("axiosData")
  console.log(axiosData)


  },
  methods: {
  deleteItem(index) {
  this.$store.commit(CART_DELETE, index)

  console.log("Deleting index=",index)
},
  checkoutNow: function() {
     // console.log("Check Out****", this.$refs["input_id"])
  //   router.push({ name: "About" });

  var parameters = {input: this.input_id, select: this.selected_id}
  this.$store.commit(CART_VALIDATE, parameters)
  console.log("Check Out****, status=", this.status)

  if (this.status == "cart-validating-success") {
  this.$router.push({ name: "Checkout" });

  }

  },
  doCustomSalesInput(naics) {
          this.orders.forEach((element, index, array) => {
          if (element.naics == naics) {
          this.orders[index].salesrange = this.input_id[element.index]
          }
            });

  console.log("doCustomSalesInput:"+naics)
  console.log(this.orders)
  },
  doCustomSales(naics) {

//     var product = {report: "Standard-1",  naics: naics, description: description, salesType: "Range", salesrange: null, salesExact:0 }

console.log("Cartviewer-mycart",this.myCart)


  this.myCart.forEach((product, index, array) => {
  console.log("Cartviewer-mycart")
  var cp = product.cartProduct
  var myproduct = {report: cp.report,  naics: cp.naics, description: cp.description, salesType: cp.salesType, salesrange: cp.salesrange, salesExact: cp.salesExact }
  if (myproduct.naics == naics) {
        if( this.selected_id[product.index] == "Input" ) {
          myproduct.salesType = "Exact"

          var renderObj = {index: product.index, selectVisible: true, inputVisible: true  }
  //        this.$store.commit(CART_RENDER, renderObj)
          this.rerender[product.index] = "visible"

        } else {
        myproduct.salesType = "Range"
        myproduct.salesrange = this.selected_id[product.index]
        var renderObj = {index: product.index, selectVisible: true, inputVisible: false  }
        this.$store.commit(CART_RENDER, renderObj)
        this.rerender[product.index] = "hidden"

        }

//        this.$store.commit(CART_UPDATE, myproduct)

  }

        });

      console.log("doCustomSales:"+naics)
  },
  loadTable() {

  },
  toggleItem(rowindex) {
      console.log("Toggle Item",this.rerender)
      this.rerender.forEach((render, index, array) => {
          console.log("rerender.foreach",rowindex,index,render)
          if (this.rerender[index] == "visible") {
          this.rerender[index] = "hidden"
          } else {
          this.rerender[index] = "visible"

          }
  });

  },
    downloadCSV() {

  },
    trashModal (trashObject) {
      this.trashObject = trashObject
      this.isModalActive = true
    },
    trashConfirm () {
      this.isModalActive = false
      this.$buefy.snackbar.open({
        message: 'Confirmed',
        queue: false
      })
    },
    trashCancel () {
      this.isModalActive = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CartViewer.vue